import {createContext} from 'react';

import usePaymentPanel from './hooks/usePaymentPanel';

const PaymentPanelContext = createContext<ReturnType<typeof usePaymentPanel>>({
    clearError: () => {},
    error: null,
    isLoading: true,
    isPaid: false,
    pollCount: {current: 0},
    setError: () => {},
    setGenericError: () => {},
    setIsLoading: () => {},
    setIsPaid: () => {},
    setTimeoutError: () => {},
});

export default PaymentPanelContext;
